<template>
  <div class="flex items-center">
    <vx-tooltip position="top"
                :text="tooltipText"
                class="flex items-center"
                :enabled="true"
    >
      <img :src="schedulerIcon"
           alt="scheduler icon"
           :class="iconClass"
      >
    </vx-tooltip>
  </div>
</template>

<script>
import moment from 'moment'
import schedulerIcon from '@/assets/images/icons/scheduler_icon.svg'
import { stringToArray, getSchedule } from 'cron-converter'

export default {
  name: 'IndexExecutionNextUpdate',

  props: {
    cronExpression: {
      type: String,
      required: true
    },
    iconClass: {
      type: String,
      default: ''
    }
  },

  data() {
    return {
      schedulerIcon
    }
  },

  computed: {
    nextUpdate() {
      const cronExpression = stringToArray(this.cronExpression)
      const schedule = getSchedule(cronExpression, new Date(), 'UTC')
      return schedule.next().toMillis()
    },
    tooltipText() {
      return `Next update:<br/>${moment(this.nextUpdate).format('LL HH:mm:ss')}`
    }
  }
}
</script>
